export default "__VITE_ASSET__af94256c__"